import {
  useRef,
  useLayoutEffect,
  useState,
  type ComponentPropsWithoutRef,
  type CSSProperties,
} from "react";
import { SmoothCollapseContainer } from "./styles";

export interface SmoothCollapseProps extends ComponentPropsWithoutRef<"div"> {
  open: boolean;
}

export function SmoothCollapse({
  open,
  children,
  ...props
}: SmoothCollapseProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (open && ref.current) {
      setHeight(ref.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [open, children]);

  return (
    <SmoothCollapseContainer
      style={{ "--input-height": `${height}px` } as CSSProperties}
      aria-hidden={!open}
      open={open}
      {...props}
    >
      <div ref={ref}>{children}</div>
    </SmoothCollapseContainer>
  );
}
